import Vue from 'vue'
import { Table, Button, Modal, message } from 'ant-design-vue'
import '@/assets/css/l8-model.less'
Vue.config.productionTip = false
Vue.use(Table)
Vue.use(Button)
Vue.use(Modal)
Vue.prototype.$message = message
